import {createContext, useContext, useEffect, useReducer} from 'react';
import reducer from '../Functions/reducer';
import {Authorization} from './AuthContextProvider';
import axios from 'axios';


const initState = {
    items: [],
    itemsCounter: 0,
    total: 0,
    total_price: 0,
    address: {},
}

export const CartContext = createContext()

const CartContextProvider = ({children}) => {
    const {user, tokens} = useContext(Authorization)
    const [state, dispatch] = useReducer(reducer, initState)

    useEffect(() => {
        const storage = JSON.parse(localStorage.getItem("cart"));
        if (storage) dispatch({type: "INIT_STORED_CART", payload: storage});
        else dispatch({type: "INIT_STORED_CART", payload: initState});
    }, [tokens]);

    useEffect(() => {
        let timer;
        if (!!Object.keys(user).length) {
            if (!!state.items.length) {
                timer = setTimeout(() => {
                    const update = async () => {
                        await axios.put('shopping-cart/store', state,
                            {headers: {Authorization: `${tokens.token_type} ${tokens.access_token}`}})
                            .then(res => dispatch({type: "UPDATE_CART", payload: res.data.data}))
                            .catch(err => alert(err.response?.data.message))
                            .finally(() => dispatch({type: 'REMOVE_LOADING', payload: []}))
                    }
                    update()
                }, 2000);
            }
        }
        return () => clearTimeout(timer);
    }, [state.reload])


    return (
        <>
            <CartContext.Provider value={{state, dispatch}}>
                {children}
            </CartContext.Provider>
        </>
    );
};

export default CartContextProvider;